<template>
	<ui-modal @toggle="$emit('toggle')">
		<Head title="Création d'une structure" />
		<form method="post" @submit.prevent="handleSubmit" class="flex flex-col lg:grid lg:grid-cols-2 gap-2">
			<ui-title textSize="big" textPosition="left" class="lg:col-span-2 text-slate-700">
				<template v-slot:text>
					<p>Ajouter une structure</p>
				</template>
			</ui-title>
			<span class="flex justify-between gap-2 items-center col-span-2">
				Cibler la structure ? :
				<ui-toggle v-model="form.targeted" :icons="['fa-crosshairs', 'fa-crosshairs']" />
			</span>
			<!-- NAME -->
			<form-input placeholder="Nom de la structure *" v-model="form.name" class="lg:col-span-2"> </form-input>
			<!-- TYPE -->
			<form-select
				:items="page.props.str.statuses.filter((status) => status.type == 'structure')"
				placeholder="Type *"
				@valueChange="form.type = $event"
				:value="form.type"
				class="col-span-2">
			</form-select>
			<!-- STATUS -->
			<form-select
				:items="page.props.str.statuses.filter((status) => status.type == 'progress')"
				placeholder="Status *"
				@valueChange="form.status = $event"
				:value="form.status"
				class="col-span-2">
			</form-select>
			<!-- TARGET -->
			<form-select
				:items="page.props.str.statuses.filter((status) => status.type == 'target')"
				placeholder="Cible*"
				@valueChange="form.target = $event"
				:value="form.target?.id ? form.target?.id : form.target"
				class="col-span-2">
			</form-select>
			<!-- ADDRESS -->
			<form-input placeholder="Adresse *" v-model="form.address" class="lg:col-span-2"> </form-input>
			<!-- CITY + POSTAL CODE -->
			<form-input v-model="form.postal_code" placeholder="Code Postal *"> </form-input>
			<form-input v-model="form.city" placeholder="Ville *"> </form-input>
			<!-- PHONE + EMAIL -->
			<form-input v-model="form.phone" placeholder="Numéro de téléphone"> </form-input>
			<form-input v-model="form.email" placeholder="E-Mail"> </form-input>
			<!-- COMMENT -->
			<form-textarea :placeholder="'Commentaire'" v-model="form.comment" class="col-span-2"> </form-textarea>
			<!-- PRO_ID -->
			<form-input placeholder="Numéro professionnel (FINESS)" v-model="form.pro_id" class="lg:col-span-2"> </form-input>
			<!-- DR -->
			<form-select
				v-if="page.props.auth.user?.role == 'admin'"
				:items="page.props.admin.users"
				prefix="Délégué(e) régional(le) : "
				placeholder="Délégué(e) régional(le)"
				@valueChange="form.dr_id = $event"
				:value="form.dr_id"
				class="col-span-2">
				<template v-slot:icon>
					<i class="fas fa-caret-down"></i>
				</template>
			</form-select>
			<form-validation-errors class="lg:col-span-2"></form-validation-errors>
			<ui-button class="col-span-2 mt-3 font-bold border-2" position="center" @click.prevent="handleSubmit()" :loading="loading">
				<template v-slot:text>Valider</template>
			</ui-button>
		</form>
	</ui-modal>
</template>

<script setup>
	import { ref, onMounted } from 'vue';
	import { Head, useForm, usePage, router } from '@inertiajs/vue3';
	import { toast } from 'vue3-toastify';

	const page = usePage();

	const emit = defineEmits(['toggle']);

	const loading = ref(false);

	const form = useForm({
		targeted: false,
		name: null,
		status: null,
		target: null,
		type: null,
		address: null,
		compl_address: null,
		postal_code: null,
		city: null,
		email: null,
		phone: null,
		dr_id: null,
		pro_id: null,
		comment: null,
	});

	const handleSubmit = () => {
		loading.value = true;
		form.post(route('structures.store'), {
			preserveScroll: true,
			onSuccess: () => {
				router.visit(route('structures.index'));
				toast.success('Structure créée avec succès !');
			},
			onFinish: () => {
				loading.value = false;
			},
		});
	};

	onMounted(() => {
		// Récupérer l'id de l'utilisateur connecté
		form.dr_id = page.props.auth.user.id;
	});
</script>
